import { DataImportantStatusEnum } from "../../user/types";
import { IFormData, OrderState, OrderStatusType, PaymentMethodType } from "../types";

export const defaultFormData: IFormData = {
  _id: "",
  orderId: "",
  status: OrderStatusType.PENDING,
  payment_status: "",
  subTotal: 0,
  totalShipmentCapacity: 0,
  shipmentCharges: 0,
  totalPrice: 0,
  taxAmount: 0,
  firstName: "",
  lastName: "",
  japaneseFirstName: "",
  japaneseLastName: "",
  postCode: "",
  state: "",
  district: "",
  streetAddress: "",
  mobileNumber: "",
  email: "",
  companyName: "",
  japaneseCompanyName: "",
  department: "",
  alternateFirstName: "",
  alternateLastName: "",
  alternateJapaneseFirstName: "",
  alternateJapaneseLastName: "",
  alternatePostCode: "",
  alternateState: "",
  alternateDistrict: "",
  alternateStreetAddress: "",
  alternateMobileNumber: "",
  alternateCompanyName: "",
  alternateJapaneseCompanyName: "",
  alternateDepartment: "",
  remarks: "",
  deliveryTimeSlot: "",
  order_items: [],
  paymentMethod: PaymentMethodType.STRIPE,
  importantStatus: DataImportantStatusEnum.Null,
  store: "",
  customerId: "", // Optional field for customer ID
};

export const initialState: OrderState = {
  list: [],
  loading: false,
  buttonLoading: false,
  search: "",
  pageNo: 1,
  pageSize: 30,
  totalRow: 0,
  orderBy: "",
  orderDir: "",
  formData: { ...defaultFormData },
  endDate: null,
  startDate: null,
  holdItems: [],
  shippingForm: {
    deliveryCompany: "",
    estimatedDeliveryDate: null,
    trackingUrl: "",
    trackingNo: "",
  },
  filter: OrderStatusType.NULL
};
